import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import ConnectIntegrationButton from "../../../common/button/connectintegrationbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { ConfigurationPipedrive } from "../../../state/integration/IntegrationConfiguration"
import ConfigurationValueComponent from "../ConfigurationValueComponent"
import { renderConfigurationLabel } from "../../../utils/integration/pipedrive"
import IntegrationConfigurationValue, { IntegrationConfigurationValueDto } from "../../../state/integration/IntegrationConfigurationValue"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: ConfigurationPipedrive,
    configurationValues: Array<IntegrationConfigurationValueDto>,
    onConfigurationChange: (configuration: ConfigurationPipedrive) => void,
    intl: Intl,
}

const PipedriveFormComponent = (props: OwnProps) => {
    if (!props.integrationConfigurationId) {

        const url = AppContext.getOptions().apiUrl + `/openid/connect/${INTEGRATION_KEY.PIPEDRIVE}/` +
            AppContext.getUserLoggedIn().id

        return <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right">
                    <FormattedMessage
                        id="integration.form.edit.connect"
                        defaultMessage="Connect"
                    />
                </label>
                <div className="col-9">
                    <ConnectIntegrationButton integrationKey={INTEGRATION_KEY.PIPEDRIVE} url={url} />
                </div>
            </div>
        </div>
    }


    return <div className="col-12 ui-module">
        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.pipedrive.account_id"
                    defaultMessage="Company ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="companyDomain">
                <FormattedMessage
                    id="integration.form.edit.pipedrive.company_domain"
                    defaultMessage="Company Domain"
                />
            </label>
            <div className="col-9">
                <input
                    name="companyDomain"
                    value={props.configuration.companyDomain}
                    disabled={true}
                    id="companyDomain"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="externalUserId">
                <FormattedMessage
                    id="integration.form.edit.pipedrive.user_id"
                    defaultMessage="Pipedrive User ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="externalUserId"
                    value={props.configuration.externalUserId}
                    disabled={true}
                    id="externalUserId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="userFullName">
                <FormattedMessage
                    id="integration.form.edit.pipedrive.user_fullname"
                    defaultMessage="Pipedrive user's name"
                />
            </label>
            <div className="col-9">
                <input
                    name="userFullName"
                    value={props.configuration.userFullName}
                    disabled={true}
                    id="userFullName"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        {props.configurationValues.map(v => {
            const cv = new IntegrationConfigurationValue(v)
            return (
                <ConfigurationValueComponent
                    key={cv.getId()}
                    configurationValue={cv}
                    value={props.configuration[cv.getKey()]}
                    onChange={value => {
                        props.configuration[cv.getKey()] = value
                        props.onConfigurationChange(props.configuration)
                    }}
                    renderConfigurationValueLabel={renderConfigurationLabel}
                    intl={props.intl}
                />
            )
        })}


    </div>
}

export default injectIntl(PipedriveFormComponent)


// WEBPACK FOOTER //
// ./src/integration/form/pipedrive/pipedriveFormComponent.tsx